import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { StakingAnylyticsInfo } from "src/models/StakingPool";
import { formatNumber } from "src/utils/numberUtils";

export const StakingAnalytics = (props: {
  info: StakingAnylyticsInfo | undefined;
}) => {
  return (
    <Box pt="56px" pb="60px">
      <Stack direction="row" alignSelf="stretch" justifyContent="center">
        <Stack alignItems="center" spacing={2}>
          <Typography fontSize="22px" color="#797979">
            Total Staked Value
          </Typography>

          <Typography variant="bold" fontSize="30px" color="white">
            ${props.info ? formatNumber(props.info.totleStakeAmount, 2) : "--"}
          </Typography>
        </Stack>

        <Stack alignItems="center" spacing={2} mx="165px">
          <Typography fontSize="22px" color="#797979">
            Delegated Value
          </Typography>

          <Typography variant="bold"  fontSize="30px" color="white">
            ${props.info ? formatNumber(props.info.delegateAmount, 2) : "--"}
          </Typography>
        </Stack>

        <Stack alignItems="center" spacing={2}>
          <Typography fontSize="22px" color="#797979">
            Operated Nodes
          </Typography>

          <Typography variant="bold" fontSize="30px" color="white">
            {props.info ? props.info.nodeAmount : "--"}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
